module.exports = __webpack_public_path__ + "static/media/logo.06c29901.svg";